import {$http} from '@/utils/https'

import {GET_LIST} from './types/action-types';

import {GET_LIST_LOADING, SET_LIST,} from './types/mutation-types';

const state = {
    list: [],
    isListLoading: false,
};

const getters = {
    list: state => state.list,
    isListLoading: state => state.isListLoading,
};

const actions = {
    [GET_LIST]: async ({state, commit}) => {
        if (state.isListLoading) {
            return
        }

        try {
            commit(GET_LIST_LOADING, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}my/certificates?include=course,userCourse,certificate`);

            commit(SET_LIST, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(GET_LIST_LOADING, false);
        }
    },// eslint-disable-next-line
};

const mutations = {
    [SET_LIST](state, data) {
        state.list = data;
    },
    [GET_LIST_LOADING](state, status) {
        state.isListLoading = status;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
